import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ngxPlural' })
export class PluralPipe implements PipeTransform {

  transform(input: number, label: string, pluralLabel= ''): string {
    const response = input || 0 as number;

    return response === 1
      ? `${response} ${label}`
      : pluralLabel
        ? `${response} ${pluralLabel}`
        : `${response} ${label}s`;
  }
}
